import { useCallback } from "react";
import { useParams } from "react-router";

import useTypedContext from "hooks/useTypedContext";
import useCommitSpaceliftVcsFiles from "shared/SpaceliftVcsRepo/useCommitSpaceliftVcsFiles";
import { RepoCommitFileInput } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

const useRepoCommit = () => {
  const { repoId } = useParams<{ repoId: string }>();
  const { viewer } = useTypedContext(AccountContext);
  const { commitFiles, loading } = useCommitSpaceliftVcsFiles();

  const commit = useCallback(
    (
      files: RepoCommitFileInput[],
      commitMessage: string,
      commitDescription: string,
      onSuccess?: (commitId: string) => void
    ) => {
      if (!repoId) return;

      commitFiles(
        {
          repoID: repoId,
          message: commitMessage,
          description: commitDescription || null,
          authorName: viewer.name,
          authorEmail: viewer.email,
          files,
        },
        onSuccess
      );
    },
    [repoId, viewer.name, viewer.email, commitFiles]
  );

  return { commit, loading };
};

export default useRepoCommit;
